"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Input_1 = __importDefault(require("../Input/Input"));

var styled_1 = require("./styled");
/**
 * Toggle component, <input type="checkbox"> with a toggle style
 *
 */


var Toggle = function Toggle(_a) {
  var _a$checked = _a.checked,
      checked = _a$checked === void 0 ? false : _a$checked,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      props = __rest(_a, ["checked", "disabled"]);

  return react_1["default"].createElement(Input_1["default"], Object.assign({
    type: Input_1["default"].Types.Checkbox,
    label: function label(_a) {
      var rest = __rest(_a, []);

      return react_1["default"].createElement(styled_1.Label, null, react_1["default"].createElement("input", Object.assign({
        type: Input_1["default"].Types.Checkbox,
        checked: checked || undefined,
        disabled: disabled
      }, rest)), react_1["default"].createElement("span", null));
    }
  }, props));
};

exports["default"] = Toggle;